import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'

// TODO: ボタンのデザイン統一したら削除する
export const Button = styled.button`
  border-radius: 20px;
  padding: 6px 12px;

  font-size: 14px;
  font-weight: ${fontWeightBold};
  line-height: 1.4;
  text-align: center;
  white-space: nowrap;
`

export const LargeButton = styled.button`
  border-radius: 5px;
  padding: 10px 81px;

  font-size: 14px;
  font-weight: ${fontWeightBold};
  height: 50px;
  text-align: center;
  white-space: nowrap;
`

export const SmallButton = styled.button`
  border-radius: 5px;
  padding: 10px 24px;

  font-size: 12px;
  font-weight: ${fontWeightBold};
  text-align: center;
  white-space: nowrap;
`
